import { render, staticRenderFns } from "./nearexpiration.vue?vue&type=template&id=6b13313e&"
import script from "./nearexpiration.vue?vue&type=script&lang=js&"
export * from "./nearexpiration.vue?vue&type=script&lang=js&"
import style0 from "./nearexpiration.vue?vue&type=style&index=0&id=6b13313e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports